import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
  state: () => ({
    dialogList: [],       // [{ name, emotion, text, options:[{text, branch?, onSelect?}] , branch?: number }]
    currentIndex: 0,
    visible: false,
    resolve: null,        // Promise.resolve
  }),

  actions: {
    /**
     * 显示对话（可包含选项）
     * 调用方可：await showDialogAsync([...]) 得到用户选择的分支值（或 undefined）
     */
    showDialogAsync(dialogs = []) {
      console.log('[DialogStore] showDialogAsync | dialogs=', dialogs)
      return new Promise(resolve => {
        this.dialogList = dialogs || []
        this.currentIndex = 0
        this.visible = true
        this.resolve = resolve
      })
    },

    /**
     * 选项点击：根据当前对话项的 options[index]
     * - 执行 onSelect（支持异步）
     * - 计算返回值：优先 opt.branch；否则返回 index+1
     * - 关闭并 resolve(returnValue)
     */
    async selectOption(index) {
      const cur = this.dialogList[this.currentIndex] || {}
      const opts = cur.options || []
      const opt = opts[index]
      console.log('[DialogStore] selectOption | index=', index, 'opt=', opt)

      if (!opt) {
        console.warn('[DialogStore] selectOption | invalid index')
        return
      }

      if (typeof opt.onSelect === 'function') {
        try {
          console.log('[DialogStore] selectOption | running onSelect...')
          await opt.onSelect()
        } catch (e) {
          console.warn('[DialogStore] selectOption | onSelect error:', e)
        }
      }

      const ret = (opt.branch != null) ? opt.branch : (index + 1)
      console.log('[DialogStore] selectOption | resolve ret=', ret)

      this.visible = false
      if (this.resolve) {
        const r = this.resolve
        this.resolve = null
        r(ret)
      }
    },

    /**
     * 分支跳转（保留兼容：若找不到目标分支，则直接 resolve(branch)）
     * 用于某些老逻辑在同一轮对话内跳转到带 branch 的节点。
     */
    goBranch(branch) {
      console.log('[DialogStore] goBranch ->', branch)
      const idx = this.dialogList.findIndex(d => d && d.branch === branch)
      if (idx >= 0) {
        this.currentIndex = idx
        console.log('[DialogStore] goBranch | jump to index=', idx)
      } else {
        console.log('[DialogStore] goBranch | no target node, resolve with branch')
        this.visible = false
        if (this.resolve) {
          const r = this.resolve
          this.resolve = null
          r(branch)
        }
      }
    },

    /**
     * 继续：纯文本对话推进；最后关闭并 resolve(undefined)
     */
    nextDialog() {
      if (this.currentIndex < this.dialogList.length - 1) {
        this.currentIndex++
        console.log('[DialogStore] nextDialog | index=', this.currentIndex)
      } else {
        console.log('[DialogStore] nextDialog | end & resolve()')
        this.visible = false
        if (this.resolve) {
          const r = this.resolve
          this.resolve = null
          r()
        }
      }
    },

    /**
     * 主动关闭：resolve(undefined)
     */
    closeDialog() {
      console.log('[DialogStore] closeDialog')
      this.visible = false
      if (this.resolve) {
        const r = this.resolve
        this.resolve = null
        r()
      }
    }
  }
})
